module.exports = __webpack_public_path__ + "static/media/1019887.e3901806.jpg";